import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { Card } from "@/core/components/ui/card";
import { Typography } from "@/core/components/ui/typography";
import { dayjs } from "@/core/utils/date";
import { formatMoney } from "@/core/utils/money";
import { cn } from "@/core/utils/utils";
import type { IcmLineItem } from "@/icm/types";

export const StatementLineItemCard = ({
  lineItem,
  onClick,
}: {
  lineItem: IcmLineItem;
  onClick: () => void;
}) => (
  <button type="button" onClick={onClick} className="w-full text-left">
    <Card
      className={cn("p-4 transition-colors hover:bg-surface-secondary/50", {
        "border-gold-20 bg-gold-5/30": lineItem.warnings.length > 0,
      })}
    >
      <div className="flex items-center gap-3">
        <div className="min-w-0 flex-1">
          <Typography variant="subtitleW2" className="truncate leading-snug">
            {lineItem.customer_name ?? lineItem.payout_rule_name}
          </Typography>
          <Typography variant="bodyW3" textColor="secondary">
            {lineItem.job_completed_on
              ? dayjs(lineItem.job_completed_on).format("MMM D, YYYY")
              : "No completion date"}
          </Typography>
          {lineItem.warnings.length > 0 && (
            <Typography className="mt-0.5 text-sm text-gold-70">
              {lineItem.warnings[0]}
            </Typography>
          )}
        </div>
        <div className="flex shrink-0 items-center gap-1">
          <Typography variant="subtitleW2">
            {formatMoney(lineItem.payout_amount) ?? "-"}
          </Typography>
          <ChevronRightIcon className="h-4 w-4 text-tertiary-text" />
        </div>
      </div>
    </Card>
  </button>
);
